import React from 'react';
import { Link } from 'react-router-dom';
import Container from './Container';

const Footer = () => {
  const sections = [
    {
      title: 'Προϊόν',
      links: [
        { text: 'Χαρακτηριστικά', href: '#features' },
        { text: 'Τιμολόγηση', href: '/pricing' },
        { text: 'Συχνές Ερωτήσεις', href: '/faq' },
      ]
    },
    {
      title: 'Εταιρεία',
      links: [
        { text: 'Σχετικά με εμάς', href: '/about' }, // Εδώ μπήκε το Σχετικά
        { text: 'Επικοινωνία', href: '/contact' },
      ]
    },
    {
      title: 'Νομικά',
      links: [
        { text: 'Όροι Χρήσης', href: '/terms' },
        { text: 'Πολιτική Απορρήτου', href: '/privacy' },
      ]
    }
  ];

  return (
    <footer style={{
      backgroundColor: '#111827',
      color: '#9CA3AF',
      padding: '5rem 0 2rem 0',
      borderTop: '1px solid #2D3748'
    }}>
      <Container>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '3rem',
          marginBottom: '4rem'
        }}>
          {/* Logo Column */}
          <div style={{ gridColumn: 'span 1.5' }}>
            <div style={{ 
              fontSize: '1.5rem', 
              fontWeight: '800', 
              color: 'white', 
              marginBottom: '1rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}>
              <span style={{ color: '#10B981' }}>Tail</span>Clinic
            </div>
            <p style={{ lineHeight: '1.6', fontSize: '0.9rem', maxWidth: '250px', marginBottom: '1.5rem' }}>
              Η ολοκληρωμένη πλατφόρμα διαχείρισης για τον σύγχρονο κτηνίατρο.
            </p>
            {/* Email */}
            <a href="mailto:support@tailclinic.gr" style={{ 
              color: 'white', 
              textDecoration: 'none', 
              fontSize: '0.9rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}>
              <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
              support@tailclinic.gr
            </a>
          </div>

          {/* Links Columns */}
          {sections.map((section) => (
            <div key={section.title}>
              <h4 style={{ color: 'white', fontWeight: '700', marginBottom: '1.5rem', fontSize: '1rem' }}>
                {section.title}
              </h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {section.links.map((link) => (
                  <li key={link.text} style={{ marginBottom: '0.75rem' }}>
                    <Link 
                      to={link.href} 
                      style={{ 
                        color: '#9CA3AF', 
                        textDecoration: 'none', 
                        fontSize: '0.9rem',
                        transition: 'color 0.2s'
                      }}
                      onMouseEnter={(e) => e.target.style.color = '#10B981'}
                      onMouseLeave={(e) => e.target.style.color = '#9CA3AF'}
                    >
                      {link.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid #2D3748',
          paddingTop: '2rem',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '1.5rem'
        }}>
          <div style={{ fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <span>© 2026 TailClinic.</span>
            <span style={{ color: '#4B5563' }}>|</span>
            <span>Designed & Built with ❤️ in <strong>Thessaloniki</strong></span>
          </div>
          
          <div style={{ display: 'flex', gap: '1rem' }}>
            {/* Facebook */}
            <a href="#" style={{ color: '#9CA3AF', backgroundColor: '#1F2937', padding: '0.5rem', borderRadius: '50%', display: 'flex' }} onMouseEnter={(e) => e.currentTarget.style.color = '#10B981'} onMouseLeave={(e) => e.currentTarget.style.color = '#9CA3AF'}>
              <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/></svg>
            </a>
            {/* Instagram */}
            <a href="#" style={{ color: '#9CA3AF', backgroundColor: '#1F2937', padding: '0.5rem', borderRadius: '50%', display: 'flex' }} onMouseEnter={(e) => e.currentTarget.style.color = '#10B981'} onMouseLeave={(e) => e.currentTarget.style.color = '#9CA3AF'}>
              <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M12.315 2c2.43 0 2.784.013 3.808.06 3.64.166 5.387 1.914 5.553 5.553.046 1.024.06 1.379.06 3.808 0 2.43-.013 2.784-.06 3.808-.166 3.64-1.913 5.387-5.553 5.553-1.024.046-1.379.06-3.808.06-2.43 0-2.784-.013-3.808-.06-3.64-.166-5.387-1.914-5.553-5.553-.046-1.024-.06-1.379-.06-3.808 0-2.43 0-2.784.013-3.808-.166-3.64 1.913-5.387 5.553-5.553 1.024-.046 1.379-.06 3.808-.06zm0-2c-2.484 0-2.833.014-4.225.078-4.52.206-7.04 2.724-7.245 7.245-.064 1.392-.078 1.741-.078 4.225 0 2.484.014 2.833.078 4.225.206 4.52 2.724 7.04 7.245 7.245 1.392.064 1.741.078 4.225.078 2.484 0 2.833-.014 4.225-.078 4.52-.206 7.04-2.724 7.245-7.245.064-1.392.078-1.741.078-4.225 0-2.484-.014-2.833-.078-4.225-.206-4.52-2.724-7.04-7.245-7.245-1.392-.064-1.741-.078-4.225-.078zM12 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;